import { type ThemaFromThemaRouter } from '../dtos';

export const printCservFormat = (thema: ThemaFromThemaRouter): string =>
  `${thema.strukturellesFormat.toString()} ${thema.strukturellesFormatBeschreibung}`;
